module.exports = __webpack_public_path__ + "static/heroOlympo35-577c70f2539f27346e2dbff36bcea939.png";